var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z",
    stroke: "#02B151",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z",
    stroke: "#02B151",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14L16 9L5 20",
    stroke: "#02B151",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#02B151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98 22V15.52H7.156C7.54533 15.52 7.86533 15.5947 8.116 15.744C8.36667 15.888 8.55333 16.1013 8.676 16.384C8.79867 16.6613 8.86 17 8.86 17.4C8.86 17.9013 8.77733 18.2853 8.612 18.552C8.44667 18.8133 8.22267 18.9947 7.94 19.096C7.65733 19.1973 7.34 19.248 6.988 19.248H6.412V22H4.98ZM6.412 18.248H6.892C7.068 18.248 7.20133 18.216 7.292 18.152C7.38267 18.088 7.44133 17.992 7.468 17.864C7.5 17.736 7.516 17.5733 7.516 17.376C7.516 17.2107 7.50267 17.0667 7.476 16.944C7.45467 16.816 7.39867 16.7147 7.308 16.64C7.21733 16.5653 7.076 16.528 6.884 16.528H6.412V18.248ZM10.0303 22V15.52H11.0383L12.3663 18.64V15.52H13.5503V22H12.5823L11.2543 18.64V22H10.0303ZM16.6827 22.096C16.2347 22.096 15.88 22.0027 15.6187 21.816C15.3627 21.6293 15.1787 21.368 15.0667 21.032C14.96 20.6907 14.9067 20.2987 14.9067 19.856V17.68C14.9067 17.2213 14.9654 16.824 15.0827 16.488C15.2 16.152 15.4 15.8933 15.6827 15.712C15.9707 15.5253 16.36 15.432 16.8507 15.432C17.3307 15.432 17.7067 15.512 17.9787 15.672C18.256 15.832 18.4534 16.0533 18.5707 16.336C18.688 16.6187 18.7467 16.9493 18.7467 17.328V17.744H17.3467V17.216C17.3467 17.0773 17.336 16.9493 17.3147 16.832C17.2987 16.7147 17.256 16.6213 17.1867 16.552C17.1227 16.4773 17.016 16.44 16.8667 16.44C16.712 16.44 16.6 16.4827 16.5307 16.568C16.4614 16.648 16.416 16.7493 16.3947 16.872C16.3787 16.9947 16.3707 17.1227 16.3707 17.256V20.256C16.3707 20.4 16.384 20.536 16.4107 20.664C16.4427 20.7867 16.496 20.888 16.5707 20.968C16.6507 21.0427 16.7627 21.08 16.9067 21.08C17.056 21.08 17.1707 21.04 17.2507 20.96C17.3307 20.88 17.3867 20.776 17.4187 20.648C17.4507 20.52 17.4667 20.384 17.4667 20.24V19.48H16.8827V18.64H18.7547V22H17.8107L17.7307 21.464C17.6454 21.6453 17.52 21.7973 17.3547 21.92C17.1894 22.0373 16.9654 22.096 16.6827 22.096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.a6ee70b5a0f9703ea24de636748cefda.svg";
export { ForwardRef as ReactComponent };